/** Formato de número de egreso (prefijo + consecutivo, igual que factura no electrónica). */
export const formatEgresoNumero = (prefijo, numero) => {
    if (numero == null || numero === '') return '';
    const n = String(numero).padStart(4, '0');
    return prefijo ? `${prefijo}-${n}` : n;
};

export const egresoDisplayFromResponse = (data) =>
    data?.numero_display
    || data?.numero_egreso_display
    || formatEgresoNumero(data?.prefijo ?? data?.prefijo_egreso, data?.numero ?? data?.numero_egreso);

export const egresoDisplayFromRow = (row) =>
    formatEgresoNumero(row?.prefijo, row?.numero);
